// src/pages/Login.jsx
import { Toaster } from "react-hot-toast";

/* ---- Shared UI ---- */
import TopBar from "../components/ui/TopBar";
import SectionCard from "../components/ui/SectionCard";

/* ---- Reusable Auth Form ---- */
import LoginForm from "../components/auth/LoginForm";

/* ---- Page palette ---- */
const PALETTE = {
  bg: "var(--rb-bg, #F5F6F8)",
  subtle: "var(--rb-subtle, #6B7280)",
};

export default function Login() {
  return (
    <div className="min-h-screen" style={{ background: PALETTE.bg }}>
      <Toaster position="top-right" />
      <TopBar />

      <div className="max-w-5xl mx-auto px-4 py-8">
        <div className="grid md:grid-cols-2 gap-6">
          <SectionCard title="Sign in to Routesbook">
            <LoginForm />
          </SectionCard>

          {/* Right column: optional helper / marketing block */}
          <div className="hidden md:block">
            <SectionCard title="Welcome back 👋">
              <p className="text-sm" style={{ color: PALETTE.subtle }}>
                Use Google or your mobile number with a 6-digit OTP. If it’s
                your first time with phone, we’ll create your account right
                after verification.
              </p>
            </SectionCard>
          </div>
        </div>
      </div>
    </div>
  );
}

